import React, { useEffect, useState } from 'react';
import GbaLinkedRoom from './GbaLinkedRoom';
import { createGbaLinkedTransport } from './gbaLinkedTransport';

// A separate room keeps the existing local SNES/GB netplay session unchanged.
export default function GbaLinkedPage({ displayName, sidebarExtras }) {
  const [transport,setTransport] = useState(null);
  const [error,setError] = useState('');
  useEffect(() => {
    let room;
    try {
      room=createGbaLinkedTransport({ name:displayName || 'Guest', serverURL:process.env.REACT_APP_SERVER_URL || '', uploadMs:120000 });
      setTransport(room);setError('');
    } catch { setError('The server-linked game connection could not be created.'); }
    return () => { setTransport(null);room?.dispose().catch(()=>{}); };
  },[displayName]);
  if(error)return <p role="alert">{error}</p>;
  if(!transport)return <p role="status">Connecting to the linked game room…</p>;
  return <GbaLinkedRoom transport={transport} attachDisplay={transport.attachDisplay}
    onActivateAudio={transport.activateAudio} sidebarExtras={sidebarExtras}/>;
}
